<mat-card>
    <mat-card-header>
      <mat-card-title>Création de correspondance</mat-card-title>
    </mat-card-header>
    <form [formGroup]="osCorrespondanceForm" style="padding: 16x">
      <div class="column">
        <mat-form-field>
          <mat-label>Nom OS</mat-label>
          <input matInput formControlName="nomOs" required />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Type device</mat-label>
          <mat-select formControlName="type" required>
            @for (type of types; track type) {
              <mat-option [value]="type.code">{{ type.libelle }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        
      </div>
  
      <div class="row" style="justify-content: space-between" mat-dialog-actions>
        <button mat-raised-button color="warn" mat-dialog-close>Annuler</button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="osCorrespondanceForm.invalid"
          (click)="formSubmit()"
          mat-dialog-close
          type="submit"
        >
          Valider
        </button>
      </div>
    </form>
  </mat-card>
  